import { Star } from "react-feather";
import { isEmpty } from "lodash";

const ScientificUncertaintyRating = ({ scientificUncertainties }) => {
  const scientificUncertaintiesArray = Object.values(scientificUncertainties);

  // Calculate the average scientific uncertainty
  const averageScientificUncertainty =
    scientificUncertaintiesArray.reduce((a, b) => a + b * 100, 0) /
    scientificUncertaintiesArray.length;

  // 0-5 stars
  // ranges between 0 to 30, where 0 is best (5 stars) and 30 is worst (0 stars)
  const stars =
    5 - Math.min(5, Math.floor(averageScientificUncertainty / 6)) || 1;

  const StarRating = () => (
    <span className="flex gap-1">
      {Array.from({ length: 5 }, (_, i) => {
        return (
          <Star
            key={i}
            size={24}
            fill={i < stars ? "#1F4444" : "#D8D8D8"}
            stroke={i < stars ? "#1F4444" : "#D8D8D8"}
          />
        );
      })}
    </span>
  );

  const ratingLabel = ["very low", "low", "fair", "high", "very high"][
    stars - 1
  ];

  return (
    <div className="shadow-small mt-8 flex w-full flex-col gap-2 p-4">
      <div className="flex justify-between gap-4">
        <p className="font-bold">Data accuracy</p>
        {!isEmpty(scientificUncertainties) && <StarRating />}
      </div>
      <p>
        {!isEmpty(scientificUncertainties) ? (
          <>
            Your estimated emissions have a data accuracy of +/-
            {Math.round(averageScientificUncertainty)}% which is{" "}
            <span className="font-bold">{ratingLabel}</span>.
          </>
        ) : (
          <>-</>
        )}
      </p>
    </div>
  );
};

export default ScientificUncertaintyRating;
